import _typeof from "@babel/runtime/helpers/typeof";
import { useRef } from 'react';
export function useSlidesDragControls(slideDrag) {
  var isMouseDownRef = useRef(false);
  var startXRef = useRef(0);
  var scrollLeftRef = useRef(0);

  if (!slideDrag) {
    return {};
  }

  var _ref = _typeof(slideDrag) === 'object' ? slideDrag : {},
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 4 : _ref$speed;

  var onMouseDown = function onMouseDown(e) {
    isMouseDownRef.current = true;
    e.currentTarget.style.cursor = 'grabbing';
    startXRef.current = e.pageX - e.currentTarget.offsetLeft;
    scrollLeftRef.current = e.currentTarget.scrollLeft;
  };

  var onMouseLeave = function onMouseLeave(e) {
    isMouseDownRef.current = false;

    if (e.currentTarget.style.cursor === 'grabbing') {
      e.currentTarget.style.cursor = 'grab';
    }
  };

  var onMouseUp = function onMouseUp(e) {
    isMouseDownRef.current = false;

    if (e.currentTarget.style.cursor === 'grabbing') {
      e.currentTarget.style.cursor = 'grab';
    }
  };

  var onMouseMove = function onMouseMove(e) {
    if (!isMouseDownRef.current) {
      return;
    }

    e.preventDefault();
    var x = e.pageX - e.currentTarget.offsetLeft;
    var step = (x - startXRef.current) * speed; // Тут можно установить скорость скролла

    e.currentTarget.scrollLeft = scrollLeftRef.current - step;
  };

  return {
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onMouseMove: onMouseMove
  };
}